import { axios } from '~/clients';
import { SEARCH_V2 } from '~/constants/endpoints';
import { InventoryRequest, InventoryResponse } from './contracts';

const fetchInventory = (
  request: InventoryRequest,
  controller: AbortController
) =>
  axios.post<InventoryResponse>(SEARCH_V2, request, {
    signal: controller.signal
  });

export default fetchInventory;
